<template>
    <v-dialog
        v-model       = "show"
        max-width     = "900"
        class         = "white"
        :scrollable   = "false"
        content-class = "dialog-border"
        persistent
        no-click-animation
    >
        <div class="pt-2 pb-1 white" style="position: relative">
            <div class="close-button v-flex">
                <c-toolbar-button
                    class    = "ml-3"
                    size     = "28"
                    color    = "white"
                    icon     = "mdi-close"
                    :tooltip = "$t('common.close')"
                    @click   = "onCancel"
                />
            </div>
            <div class="ml-4 mb-4 mt-1 w-100" >
                <v-row dense>
                    <v-col class="col-6">
                        <c-card-iterator
                            :items          = "units"
                            :label          = "$t('unit.bulkupdate.units.title')"
                            :title-prefix   = "true"
                            :filter-height  = "74"
                            :filter         = "match"
                            :item-height    = "95"
                            :height         = "600"
                            :enable-search  = "true"
                            :show-filter    = "true"
                        >
                            <template v-slot:card="{ item }">
                                <div class="lm-border pa-3">
                                    <div class="v-flex ">
                                        <div class="primary--text">
                                            {{ item.fabricNo }}
                                        </div>
                                        <v-spacer />
                                        <div class="address">
                                            {{ item.country.name }}
                                        </div>
                                    </div>

                                    <v-divider class="mt-1 mb-1" />

                                    <div class="address">
                                        {{ item.street ? item.street : "---" }}, {{ item.zip ? item.zip : "---" }} {{ item.city }}
                                    </div>

                                    <div class="address">
                                        {{ item.ve ? item.ve : "---" }} / {{ item.ve2 ? item.ve2 : "---" }} / {{ item.ve3 ? item.ve3 : "---" }}
                                    </div>
                                </div>
                            </template>
                        </c-card-iterator>
                    </v-col>

                    <v-col class="col-6">
                        <div class="mt-2 mr-8">
                            <c-column-header
                                :label = "$t('unit.bulkupdate.edit.title')"
                                class  = "primary text--white"
                            />

                            <v-select
                                :items     = "operations"
                                item-value = "id"
                                item-text  = "name"
                                v-model    = "operation"
                                return-object
                            />

                            <c-customer-bulk-update-change-customer
                                v-if   = "operation && operation.id === 1"
                                :units = "units"
                                @done  = "onDone"
                            />
                        </div>
                    </v-col>
                </v-row>
            </div>
        </div>
    </v-dialog>
</template>

<script>

import CToolbarButton                  from "@/modules/core/components/utils/CToolbarButton.vue";
import CCardIterator                   from "@/modules/core/components/utils/CCardIterator.vue";
import CColumnHeader                   from "@/modules/core/components/utils/CColumnHeader.vue";
import CCustomerBulkUpdateChangeCustomer
    from "@/modules/msd/company/customer/components/controlls/CCustomerBulkUpdateChangeCustomer.vue";

export default {
    name: "DCustomerBulkUpdate",

    components: {
        CCustomerBulkUpdateChangeCustomer,
        CColumnHeader,
        CCardIterator,
        CToolbarButton
    },

    props: {
        value: {

        },

        units: {

        }
    },

    data: (vm) => ({
        show: false,
        operations: [
            { id: 1, name: vm.$t("unit.bulkupdate.edit.type1")}
        ],
        operation: null,
    }),

    mounted() {
        this.show = this.value;
    },

    watch: {
        value () {
            this.show = this.value;
        },
    },

    methods: {
        onCancel () {
            this.$emit("input", false);
        },

        onDone() {
            this.$emit("done", false);
        },

        match () {
            return true;
        }
    }
}
</script>

<style scoped>

.close-button {
    position: absolute;
    z-index: 10;
    right: 24px;
    top: 21px;
}

.address {
    font-size: 13px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

</style>